var exports = {
  "iE": "xaee3c4fa--ed4bc5--wrapper",
  "dG": "xaee3c4fa--ed4bc5--main-article-wrapper",
  "ep": "xaee3c4fa--ed4bc5--main-news-wrapper",
  "BT": "xaee3c4fa--ed4bc5--main-news-inner-wrapper",
};

module.exports = exports;
